/* import __COLOCATED_TEMPLATE__ from './table.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import templateOnlyComponent from '@ember/component/template-only';
import type { ScimGroup, Role, TableColumn, DropdownGroup } from './types';
import type { SelectGroup } from 'embercom/utils/teammates/role-dropdown-utils';

interface Args {
  sortedGroups: ScimGroup[];
  tableColumns: TableColumn[];
  groupChanges: Record<string, number | null>;
  availableRoles: Role[];
  onReorderGroups: (groups: ScimGroup[]) => void;
  onOpenGroupDetails: (group: ScimGroup) => void;
  getGroupPriority: (group: ScimGroup) => string;
  getRoleDropdownList: (groupId: string | number) => DropdownGroup[];
  getCurrentRoleNameForGroup: (groupId: string | number) => string;
  getCurrentRoleObjectForGroup: (groupId: string | number) => Role | null;
  getGroupStateDisplayName: (state: string | null) => string;
  getGroupStateColor: (state: string | null) => 'green' | 'gray';
  roleSelectGroupList: SelectGroup[];
  onSelectRoleForGroup: (groupId: string | number, role: Role | null) => void;
  canModifyGroupRole: (groupId: string) => boolean;
  getDisabledGroupRoleTooltip: (groupId: string) => string | null;
  isLoadingUserGroups: boolean;
  canEdit?: boolean;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
  Blocks: {};
}

const ScimTable = templateOnlyComponent<Signature>();
export default ScimTable;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Teammates::Scim::Table': typeof ScimTable;
    'new-settings/workspace/teammates/scim/table': typeof ScimTable;
  }
}
